import { v4 as uuid } from 'uuid';
import Semaglutide from '../assets/images/products/semaglutide.webp';
import Tirzepatide from '../assets/images/products/tirzepatide.webp';
import Ozempic from '../assets/images/products/ozempic.webp';
import Zepbound from '../assets/images/products/zepbound.webp';
import NADPlus from '../assets/images/products/nadplus.webp';
import Glutathione from '../assets/images/products/glutathione.webp';
import Metformin from '../assets/images/products/metformin.webp';
import Sermorelin from '../assets/images/products/sermorelin.webp';
import SermorelinODT from '../assets/images/products/sermorelin_odt.webp';
import GLP1Program from '../assets/images/products/glp1_program.webp';
import NADPlusNasal from '../assets/images/products/nadplus-nasal.webp';
import GlutathioneNasal from '../assets/images/products/glutathione-nasal.webp';
import MICB12 from '../assets/images/products/mic_b12-vial.webp';
import ROUTES from '../constants/routes';
import { hasAdminPermissions, hasAllStaffPermissions } from '../utils/permissions';

const NavbarMegaMenuRoutes = (authContext, products = []) => {
	return [
		{
			id: uuid(),
			menuitem: 'Weight Loss',
			children: [
				{
					id: uuid(),
					menuitem: 'Prescription GLP-1 Program',
					subtitle: 'GOOD FOR: Weight Loss, Food Noise, Metabolism',
					image: GLP1Program,
					link: '/glp1',
					show: hasAllStaffPermissions(authContext) || products?.some(p => ['OZ', 'ZE', 'SE', 'TI', 'SEGM', 'TIGM'].includes(p.shortSku) && p.purchasable && (hasAdminPermissions(authContext) || p.visibleToCustomers))
				}
				// {
				// 	id: uuid(),
				// 	menuitem: 'Sermorelin',
				// 	subtitle: 'GOOD FOR: Lean Muscle Growth, Fat Metabolism, Sleep',
				// 	image: Sermorelin,
				// 	link: ROUTES.PRODUCT_DETAILS + '/ser'
				// }
				// {
				// 	id: uuid(),
				// 	menuitem: 'Compounded Semaglutide',
				// 	subtitle: 'Same active ingredients as Ozempic® and Wegovy®',
				// 	image: Semaglutide,
				// 	link: ROUTES.PRODUCT_DETAILS + '/segm'
				// },
				// {
				// 	id: uuid(),
				// 	menuitem: 'Ozempic® (Semaglutide)',
				// 	subtitle: 'Same active ingredients as Wegovy®',
				// 	image: Ozempic,
				// 	link: ROUTES.PRODUCT_DETAILS + '/oz'
				// },
				// {
				// 	id: uuid(),
				// 	menuitem: 'Compounded Tirzepatide',
				// 	subtitle: 'Same active ingredients as Zepbound® and Mounjaro®',
				// 	image: Tirzepatide,
				// 	link: ROUTES.PRODUCT_DETAILS + '/tigm'
				// },
				// {
				// 	id: uuid(),
				// 	menuitem: 'Zepbound® (Tirzepatide)',
				// 	subtitle: 'Same active ingredients as Mounjaro®',
				// 	image: Zepbound,
				// 	link: ROUTES.PRODUCT_DETAILS + '/ze'
				// },
				// {
				// 	id: uuid(),
				// 	menuitem: 'View all Weight Loss Solutions',
				// 	button: true,
				// 	link: ROUTES.LANDING
				// }
			]
		},
		{
			id: uuid(),
			menuitem: 'Wellness & Longevity',
			children: [
				{
					id: uuid(),
					menuitem: 'NAD+ (Nicotinamide Adenine Dinucleotide)',
					subtitle: 'GOOD FOR: Energy, Focus, Organ Health & DNA Repair',
					image: NADPlus,
					link: ROUTES.PRODUCT_DETAILS + '/na',
					show: hasAllStaffPermissions(authContext) || products?.some(p => p.shortSku === 'NA' && p.purchasable && (hasAdminPermissions(authContext) || p.visibleToCustomers))
				},
				{
					id: uuid(),
					menuitem: 'NAD+ Nasal Spray',
					subtitle: 'GOOD FOR: Energy, Focus, Organ Health & DNA Repair',
					image: NADPlusNasal,
					link: ROUTES.PRODUCT_DETAILS + '/nan',
					show: hasAllStaffPermissions(authContext) || products?.some(p => p.shortSku === 'NAN' && p.purchasable && (hasAdminPermissions(authContext) || p.visibleToCustomers))
				},
				{
					id: uuid(),
					menuitem: 'Glutathione',
					subtitle: 'GOOD FOR: Cellular Defense, Inflammation, Antioxidant Protection, Healthy Aging, Energy',
					image: Glutathione,
					link: ROUTES.PRODUCT_DETAILS + '/gl',
					show: hasAllStaffPermissions(authContext) || products?.some(p => p.shortSku === 'GL' && p.purchasable && (hasAdminPermissions(authContext) || p.visibleToCustomers))
				},
				{
					id: uuid(),
					menuitem: 'Glutathione Nasal Spray',
					subtitle: 'GOOD FOR: Cellular Defense, Inflammation, Antioxidant Protection, Healthy Aging, Energy',
					image: GlutathioneNasal,
					link: ROUTES.PRODUCT_DETAILS + '/gln',
					show: hasAllStaffPermissions(authContext) || products?.some(p => p.shortSku === 'GLN' && p.purchasable && (hasAdminPermissions(authContext) || p.visibleToCustomers))
				},
				{
					id: uuid(),
					menuitem: 'Metformin',
					subtitle: 'GOOD FOR: Weight Management, Blood sugar, AMPK activation, Longevity',
					image: Metformin,
					link: ROUTES.PRODUCT_DETAILS + '/me',
					show: hasAllStaffPermissions(authContext) || products?.some(p => p.shortSku === 'ME' && p.purchasable && (hasAdminPermissions(authContext) || p.visibleToCustomers))
				}
				// {
				// 	id: uuid(),
				// 	menuitem: 'View all Wellness & Longevity Solutions',
				// 	button: true,
				// 	link: ROUTES.LANDING
				// }
			]
		},
		{
			id: uuid(),
			menuitem: 'Metabolic Support',
			children: [
				{
					id: uuid(),
					menuitem: 'Sermorelin',
					subtitle: 'GOOD FOR: Lean Muscle Growth, Fat Metabolism, Sleep',
					image: Sermorelin,
					link: ROUTES.PRODUCT_DETAILS + '/ser',
					show: hasAllStaffPermissions(authContext) || products?.some(p => p.shortSku === 'SER' && p.purchasable && (hasAdminPermissions(authContext) || p.visibleToCustomers))
				},
				{
					id: uuid(),
					menuitem: 'Sermorelin ODT (Tablets)',
					subtitle: 'GOOD FOR: Lean Muscle Growth, Fat Metabolism, Sleep',
					image: SermorelinODT,
					link: ROUTES.PRODUCT_DETAILS + '/sero',
					show: hasAllStaffPermissions(authContext) || products?.some(p => p.shortSku === 'SERO' && p.purchasable && (hasAdminPermissions(authContext) || p.visibleToCustomers))
				},
				{
					id: uuid(),
					menuitem: 'MIC-B12',
					subtitle: 'GOOD FOR: Energy, Fat Metabolism, Focus, Mood',
					image: MICB12,
					link: ROUTES.PRODUCT_DETAILS + '/lb',
					show: hasAllStaffPermissions(authContext) || products?.some(p => p.shortSku === 'LB' && p.purchasable && (hasAdminPermissions(authContext) || p.visibleToCustomers))
				}
			]
		}
		// {
		// 	id: uuid(),
		// 	menuitem: 'Learn',
		// 	children: [
		// 		{
		// 			id: uuid(),
		// 			menuitem: 'Longevity Science',
		// 			link: ROUTES.LANDING
		// 		},
		// 		{
		// 			id: uuid(),
		// 			menuitem: 'Our Blog',
		// 			link: ROUTES.LANDING
		// 		},
		// 		{
		// 			id: uuid(),
		// 			menuitem: 'Testimonials',
		// 			link: ROUTES.LANDING
		// 		},
		// 		{
		// 			id: uuid(),
		// 			menuitem: 'About',
		// 			link: ROUTES.LANDING
		// 		},
		// 		{
		// 			id: uuid(),
		// 			menuitem: 'Research',
		// 			link: ROUTES.LANDING
		// 		},
		// 		{
		// 			id: uuid(),
		// 			menuitem: 'FAQ',
		// 			link: ROUTES.LANDING
		// 		},
		// 		{
		// 			id: uuid(),
		// 			menuitem: 'Get in Touch',
		// 			link: ROUTES.LANDING
		// 		},
		// 		{
		// 			id: uuid(),
		// 			menuitem: 'Join our Community',
		// 			button: true,
		// 			link: 'https://www.facebook.com/groups/readyrxweightlosssupport'
		// 		}
		// 	]
		// }
	];
};

export default NavbarMegaMenuRoutes;
